module.exports = __webpack_public_path__ + "img/corsymo_logo.4131c5d7.png";